import { render, staticRenderFns } from "./pageRecord.vue?vue&type=template&id=618ea49d"
import script from "./pageRecord.vue?vue&type=script&lang=js"
export * from "./pageRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports